import { BulkImportCompany } from "../../Company/queries/apiTypes";
import { BulkImportContact } from "../../Contacts/queries/apiTypes";
import { CRM_ENTITY_TYPE } from "../constant";
import { CrmCompany, CrmContact } from "../types";

interface RecordType {
    record: BulkImportCompany | BulkImportContact;
    type: CrmCompany | CrmContact;
};

// Type guards to help TS know about certain type
export const isCompanyType = (obj: RecordType): obj is { record: BulkImportCompany; type: CrmCompany } => obj.type === CRM_ENTITY_TYPE.COMPANY;

export const isContactType = (obj: RecordType): obj is { record: BulkImportContact; type: CrmContact } => obj.type === CRM_ENTITY_TYPE.CONTACT;

export const getTypeSafeDataProp = (data: RecordType) => {
    if (isCompanyType(data)) return data;
    if (isContactType(data)) return { ...data, record: { ...data.record, companyName: data.record.company.name } };
    return null;
};